<template>
  <div>
    <div class="form-group">
      <label class="idx-bold">
        {{ $t('newAction.stepOne.labels.actionName') }}
      </label>

      <input
        type="text"
        @keyup="setActionName($event.target.value)"
        :value="action.name"
        id="action-name-id"
        class="form-control"
        :placeholder="placeHolderText"
        maxlength="35"
      />

      <div class="text-danger" id="action-name-size">
        {{ $t('newAction.stepOne.actionNameSize') }}
      </div>

      <div class="invalid-feedback">
        {{ $t('newAction.stepOne.actionInvalid') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data: () => ({
    placeHolderText: 'Informe o nome da ação',
  }),

  mounted() {
    if (this.action.type === 'nps-0-10' || this.action.type === 'nps-1-5') {
      this.placeHolderText = this.$t('newAction.stepOne.actionName');
    } else if (this.action.type === 'ces-1-5') {
      this.placeHolderText = this.$t('newAction.stepOne.actionCesName');
    } else if (this.action.type === 'csat-1-5') {
      this.placeHolderText = this.$t('newAction.stepOne.actionCSATName');
    } else if (this.action.type === '5-stars') {
      this.placeHolderText = this.$t('newAction.stepOne.action5StarsName');
    }
  },

  methods: {
    ...mapActions('actions', ['setActionName']),
  },

  watch: {
    'action.name': function watchActionName(value) {
      if (value.length === 35) {
        this.actionNameSize.style.display = 'block';
      } else {
        this.actionNameSize.style.display = 'none';
      }
      if (value === '') {
        this.inputActionName.classList.add('is-invalid');
      } else {
        this.inputActionName.classList.remove('is-invalid');
      }
    },
  },

  computed: {
    ...mapState('actions', ['action']),
    ...mapFields('actions', ['nowStep']),

    inputActionName() {
      return document.getElementById('action-name-id');
    },

    actionNameSize() {
      return document.getElementById('action-name-size');
    },
  },
};
</script>

<style>
#action-name-size {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/action-name/index.vue